import { z } from 'zod'
import { FIELD_CANNOT_BE_EMPTY } from '../../../../consts/validationErrors'

export const passwordAuthFormSchema = z.object({
    login: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .email({ message: 'Введите корректный email' })
        .max(240, { message: 'Максимально 240 символа' }),
    password: z
        .string({ required_error: FIELD_CANNOT_BE_EMPTY })
        .trim()
        .min(1, { message: FIELD_CANNOT_BE_EMPTY })
        .min(8, { message: 'Минимум 8 символов' })
        .max(32, { message: `Максимум 32 символов` }),
})

export type PasswordAuthFormValues = z.infer<typeof passwordAuthFormSchema>
